/**
 * Centralized Location Configuration for Pelagia OPS
 * 
 * Change these coordinates to set your vessel location.
 * All components will use these coordinates for data fetching.
 */

// Available preset locations
export const LOCATIONS = {
  HAWAII: {
    name: "Hawaii, USA",
    lat: 21.3,
    lon: -157.8,
    description: "Near Honolulu, Oahu Island",
    nearestBuoy: "51001",
    supportsNOAAWeather: true,
    timezone: "Pacific/Honolulu"
  },
  
  FRENCH_POLYNESIA: {
    name: "French Polynesia",
    lat: -17.65,
    lon: -149.43,
    description: "Near Tahiti",
    nearestBuoy: null,
    supportsNOAAWeather: false,
    timezone: "Pacific/Tahiti"
  },
  
  GALAPAGOS: {
    name: "Galápagos Islands",
    lat: -0.75,
    lon: -90.5,
    description: "Galápagos Marine Reserve",
    nearestBuoy: null,
    supportsNOAAWeather: false,
    timezone: "Pacific/Galapagos"
  },
  
  MONTEREY_BAY: {
    name: "Monterey Bay, California",
    lat: 36.8,
    lon: -121.9,
    description: "Monterey Bay Aquarium Research Area",
    nearestBuoy: "46042",
    supportsNOAAWeather: true,
    timezone: "America/Los_Angeles"
  },
  
  FLORIDA_KEYS: {
    name: "Florida Keys",
    lat: 24.6,
    lon: -81.5,
    description: "Florida Straits",
    nearestBuoy: "42036",
    supportsNOAAWeather: true,
    timezone: "America/New_York"
  },
  
  CUSTOM: {
    name: "Custom Location",
    lat: 21.3,  // Change these for your location
    lon: -157.8,
    description: "User-defined coordinates",
    nearestBuoy: null,
    supportsNOAAWeather: false,
    timezone: "UTC"
  }
};

// ⚙️ SET YOUR DEFAULT LOCATION HERE:
export const DEFAULT_LOCATION = LOCATIONS.HAWAII;

// Helper function to get current vessel location
export const getVesselLocation = () => {
  return {
    lat: DEFAULT_LOCATION.lat,
    lon: DEFAULT_LOCATION.lon,
    name: DEFAULT_LOCATION.name,
    description: DEFAULT_LOCATION.description,
    speed: 9.8,  // Simulated speed in knots
    heading: 212, // Simulated heading in degrees
  };
};

// Helper function to check if NOAA Weather API will work
export const canUseNOAAWeather = () => {
  return DEFAULT_LOCATION.supportsNOAAWeather;
};

// Get nearest buoy station ID if available
export const getNearestBuoyStation = () => {
  return DEFAULT_LOCATION.nearestBuoy;
};

// Export for display in UI
export const getCurrentLocationInfo = () => {
  return {
    name: DEFAULT_LOCATION.name,
    description: DEFAULT_LOCATION.description,
    coordinates: `${DEFAULT_LOCATION.lat.toFixed(4)}°, ${DEFAULT_LOCATION.lon.toFixed(4)}°`,
    timezone: DEFAULT_LOCATION.timezone
  };
};
